import { Row, Col } from "antd";
import { Proposal2 } from "./prop2body";
import { Prop2side } from "./prop2side";
function PropLayout2() {
  return (
    <div>
      <Row gutter={[16, 16]}>
        <Col md={6}>
          <div className="logo" style={{ marginBottom: "45px" }}>
            <img className="imgh" src="../../images/logo.png" alt="Logo" />
          </div>
          <Prop2side />
        </Col>
        <Col md={18}>
          <Proposal2 />
        </Col>
      </Row>
    </div>
  );
}

export { PropLayout2 };
